import React, {
  FC,
  forwardRef,
  ForwardRefExoticComponent,
  PropsWithChildren,
  RefAttributes,
  useImperativeHandle,
} from "react";
import { PaymentPayload } from "@lookiero/payments-front";
import { Button } from "@lookiero/sty-psp-ui";

const FAKE_PAYMENT_PAYLOAD_KEY = "__lookInFakePaymentPayload";

let startLegacyBoxCheckoutListener: (payload: PaymentPayload) => void;

const fakePaymentPayload = (): PaymentPayload =>
  ((globalThis as Record<string, unknown>)[FAKE_PAYMENT_PAYLOAD_KEY] as PaymentPayload | undefined) ??
  ({ success: true } as PaymentPayload);

const setPaymentsBridge = () => void 0;
const PaymentsQueryProvider: FC<PropsWithChildren> = ({ children }) => children;
const PaymentInstrumentSelect: FC = () => null;

interface StartLegacyBoxCheckoutFunction {
  (paymentFlowPayload: unknown): void;
}

interface PaymentFlowRef {
  readonly startLegacyBoxCheckout: StartLegacyBoxCheckoutFunction;
  readonly startCheckout: StartLegacyBoxCheckoutFunction;
}

const paymentFlowRef: PaymentFlowRef = {
  startLegacyBoxCheckout: async () => {
    startLegacyBoxCheckoutListener?.(fakePaymentPayload());
  },
  startCheckout: async () => {
    startLegacyBoxCheckoutListener?.(fakePaymentPayload());
  },
};

const PaymentFlow: ForwardRefExoticComponent<RefAttributes<PaymentFlowRef>> = forwardRef<PaymentFlowRef, unknown>(
  (_props, ref) => {
    useImperativeHandle(ref, () => paymentFlowRef, []);
    return null;
  },
);

PaymentFlow.displayName = "PaymentFlow";

interface UsePaymentStatusManagerResult {
  isLoading: boolean;
  consumePayload: (callback: (payload: PaymentPayload) => void) => void;
}

const paymentStatusManagerResult: UsePaymentStatusManagerResult = {
  isLoading: false,
  consumePayload: (callback) => {
    startLegacyBoxCheckoutListener = callback;
  },
};

const usePaymentStatusManager: (section: Section) => UsePaymentStatusManagerResult = () => paymentStatusManagerResult;

enum Section {
  BOX_CHECKOUT = "box-checkout",
  DIRECT_BUY_CHECKOUT = "direct-buy-checkout",
}

const PayButton: FC = ({ ...props }) => <Button {...props}>Pay</Button>;

export type { PaymentFlowRef };
export {
  PaymentsQueryProvider,
  PaymentInstrumentSelect,
  PaymentFlow,
  Section,
  setPaymentsBridge,
  usePaymentStatusManager,
  PayButton,
};
